// src/services/AuthService.js
import axios from 'axios';

const API_URL = 'https://ega-senegal.com/api'; // L'URL de ton backend

// ✅ Connexion (Login)
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, { email, password });

    const { accessToken, user } = response.data;

    // Stockage du token et des informations utilisateur dans le localStorage
    localStorage.setItem('authToken', accessToken);
    localStorage.setItem('user', JSON.stringify(user));

    return user;
  } catch (error) {
    console.error('Erreur de connexion:', error);
    throw error;
  }
};

// 🚪 Déconnexion (Logout)
export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
};

// 🔒 Récupérer le token d'authentification
export const getToken = () => {
  return localStorage.getItem('authToken');
};

// 👤 Vérifier si l'utilisateur est authentifié
export const isAuthenticated = () => {
  return !!getToken(); // Retourne true si le token existe
};

// 👤 Récupérer l'ID de l'utilisateur connecté
export const userId = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user._id;
};
